<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p class="center"><a id="page7"></a>For Bob—who makes everything possible for me, with my love.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795338557_epub_ded_r1.vue?3219d42e